export default "__VITE_ASSET__8226075a__"